import { render } from "./7TeamSection.vue?vue&type=template&id=a7410194&scoped=true"
import script from "./7TeamSection.vue?vue&type=script&lang=js"
export * from "./7TeamSection.vue?vue&type=script&lang=js"

import "./7TeamSection.vue?vue&type=style&index=0&id=a7410194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7410194"]])

export default __exports__